import HeroImage from "./Hero/HeroImage";
import HeroText from "./Hero/HeroText";

const Hero = () => {
  return (
    <div className="flex flex-col-reverse text-center lg:text-left lg:grid grid-cols-2 gap-8 items-center">
      <HeroText />
      <HeroImage />
    </div>
  );
};

export default Hero;
